"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExpired = void 0;
const moment_1 = __importDefault(require("moment"));
const isExpired = (lasModified) => {
    if (!lasModified)
        return true;
    return (0, moment_1.default)().diff(lasModified, 'hours') > 12; // TODO what is expired report?
};
exports.isExpired = isExpired;
